import { FHIRQueryResourceParamType_Dynamic } from './types.js';
import { FHIRQueryResourceParam_Condition_Category, FHIRQueryResourceParam_DocumentReference_Category, FHIRQueryResourceParam_DocumentReference_DocStatus, FHIRQueryResourceParam_DocumentReference_Type, FHIRQueryResourceParam_Encounter, FHIRQueryResourceParam_List_Code, FHIRQueryResourceParam_MedicationRequest_Category, FHIRQueryResourceParam_MedicationRequest_Status, FHIRQueryResourceParam_Observation_Category, FHIRQueryResourceParam_Observation_Code, FHIRQueryResourceParam_Patient, FHIRQueryResourceParam_Procedure_Category } from './categories.js';
const FHIRQueryResource_AllergyIntolerance = {
    resource: 'AllergyIntolerance',
    label: 'Allergy Intolerance',
    params: [
        FHIRQueryResourceParam_Patient,
        FHIRQueryResourceParam_Encounter,
    ]
};
const FHIRQueryResource_Binary = {
    resource: 'Binary',
    label: 'Binary',
    params: [
        FHIRQueryResourceParam_Patient,
        FHIRQueryResourceParam_Encounter,
        { param: '_id', type: FHIRQueryResourceParamType_Dynamic },
    ]
};
const FHIRQueryResource_Condition = {
    resource: 'Condition',
    label: 'Condition',
    params: [
        FHIRQueryResourceParam_Patient,
        FHIRQueryResourceParam_Encounter,
        FHIRQueryResourceParam_Condition_Category,
    ]
};
const FHIRQueryResource_DocumentReference = {
    resource: 'DocumentReference',
    label: 'Document Reference',
    params: [
        FHIRQueryResourceParam_Patient,
        FHIRQueryResourceParam_Encounter,
        FHIRQueryResourceParam_DocumentReference_Category,
        FHIRQueryResourceParam_DocumentReference_DocStatus,
        FHIRQueryResourceParam_DocumentReference_Type,
    ]
};
const FHIRQueryResource_FamilyMemberHistory = {
    resource: 'FamilyMemberHistory',
    label: 'Family Member History',
    params: [FHIRQueryResourceParam_Patient]
};
const FHIRQueryResource_Immunization = {
    resource: 'Immunization',
    label: 'Immunization',
    params: [FHIRQueryResourceParam_Patient, FHIRQueryResourceParam_Encounter],
};
const FHIRQueryResource_List = {
    resource: 'List',
    label: 'List',
    params: [FHIRQueryResourceParam_Patient, FHIRQueryResourceParam_Encounter, FHIRQueryResourceParam_List_Code],
};
const FHIRQueryResource_MedicationRequest = {
    resource: 'MedicationRequest',
    label: 'Medication Request',
    params: [
        FHIRQueryResourceParam_Patient,
        FHIRQueryResourceParam_Encounter,
        FHIRQueryResourceParam_MedicationRequest_Category,
        FHIRQueryResourceParam_MedicationRequest_Status,
    ],
};
const FHIRQueryResource_Observation = {
    resource: 'Observation',
    label: 'Observation',
    params: [
        FHIRQueryResourceParam_Patient,
        FHIRQueryResourceParam_Encounter,
        FHIRQueryResourceParam_Observation_Category,
        FHIRQueryResourceParam_Observation_Code,
    ],
};
const FHIRQueryResource_Procedure = {
    resource: 'Procedure',
    label: 'Procedure',
    params: [
        FHIRQueryResourceParam_Patient,
        FHIRQueryResourceParam_Encounter,
        FHIRQueryResourceParam_Procedure_Category,
    ],
};
export const FHIRQueryResource_Defaults = [
    FHIRQueryResource_AllergyIntolerance,
    FHIRQueryResource_Binary,
    FHIRQueryResource_Condition,
    FHIRQueryResource_DocumentReference,
    FHIRQueryResource_FamilyMemberHistory,
    FHIRQueryResource_Immunization,
    FHIRQueryResource_List,
    FHIRQueryResource_MedicationRequest,
    FHIRQueryResource_Observation,
    FHIRQueryResource_Procedure,
];
//# sourceMappingURL=resources.js.map